import React from "react";
import PropTypes from "prop-types";
import { ArticleCard } from "../../ng-components/Article/ArticleCard";
import { Image } from "../../ng-components/Image";

export function PostCardSpecial({
    post: {
        title,
        excerpt,
        link,
        heroImage,
        tags,
        series,
        author: { image: authorImage, ...postAuthor },
        publishedDate,
    },
}) {
    const author = {
        ...postAuthor,
        avatar: <Image src={authorImage.src} alt={authorImage.alt} />,
    };

    return (
        <ArticleCard
            title={title}
            excerpt={excerpt}
            heroImage={heroImage}
            link={link}
            tags={tags}
            series={series}
            publishedDate={publishedDate}
            author={author}
        />
    );
}

PostCardSpecial.propTypes = {
    post: PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        heroImage: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired,
        }),
        tags: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                link: PropTypes.string,
            })
        ),
        series: PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
        }),
        excerpt: PropTypes.string.isRequired,
        author: PropTypes.shape({
            name: PropTypes.string.isRequired,
            image: PropTypes.shape({
                src: PropTypes.string.isRequired,
                alt: PropTypes.string.isRequired,
            }),
            link: PropTypes.string,
        }).isRequired,
        publishedDate: PropTypes.string.isRequired,
    }).isRequired,
};
